export default __webpack_public_path__ + "static/media/left-arrow.a654fb53.svg";